export default {"src":"/_next/static/media/heart-filled.d1340ee5.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};